import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TeamMatchupImagePattern from '@mlb/react-patterns/components/TeamMatchupImage';
import { Img } from '@mlb/react-patterns/components/Image/image.style';
import Skeleton from '@mlb/react-patterns/components/Skeleton';
import COLORS from '@mlb/react-patterns/style/universal.color';

import Card from '../AspectRatioCard';

const ASPECT_RATIO = '16:9';
const SRCSET_WIDTH = {
    '168w': 168,
    '372w': 372,
    '640w': 640,
    '750w': 750,
    '1024w': 1024,
};
const DATA_ATTR = { loading: 'lazy' };

const TeamMatchupImage = styled(TeamMatchupImagePattern)`
    display: block;

    ${Img} {
        display: block;
    }
`;

const Date = styled.div`
    display: inline-block;
    height: 12px;
    font-family: ${({ theme }) => theme.fonts.family.primary};
    font-weight: 400;
    font-size: 12px;
    color: ${COLORS.mlbGrey3};
    margin-top: 8px;
    line-height: 12px;
    text-decoration: none;
`;

const MatchupCard = (props) => {

    const {
        awayTeamId,
        homeTeamId,
        date,
        loading,
        as,
        imgSizes,
        ...otherProps
    } = props;

    const Wrapper = as || 'div';

    return (
        <Wrapper {...otherProps}>
            <Card aspectRatio={ASPECT_RATIO}>
                {loading ? (
                    <Skeleton margin={0} />
                ) : (
                    <TeamMatchupImage
                        awayTeamId={awayTeamId}
                        homeTeamId={homeTeamId}
                        ratio={ASPECT_RATIO}
                        sizes={imgSizes}
                        srcWidth={372}
                        srcsetWidth={SRCSET_WIDTH}
                        dataAttr={DATA_ATTR}
                    />
                )}
            </Card>
            <Date>
                {loading ? <Skeleton margin={0} width={110} /> : date}
            </Date>
        </Wrapper>
    );

};

MatchupCard.propTypes = {
    awayTeamId: PropTypes.number,
    homeTeamId: PropTypes.number,
    date: PropTypes.string,
    loading: PropTypes.bool,
    imgSizes: PropTypes.string,
};

MatchupCard.defaultProps = {
    loading: false,
};

export default MatchupCard;
